import { useDispatch } from "react-redux";

import { Box, Button, Stack, Typography } from "@mui/material";
import { setDialogConfig } from "@store/slices/componentsSlice";
import { DialogType, RegistrationInPortfolioErrors } from "@interfaces/slices";

import WarningCheck from "@assets/download_warning_icon.svg";
import { store } from "@store/store";
import { useEffect, useState } from "react";

interface ErroresAltaCartera extends RegistrationInPortfolioErrors {}

export const ErroresAltaCartera = (props: ErroresAltaCartera) => {
    const dispatch = useDispatch();

    const [errors, setErrors] = useState<Array<any>>([]);

    const applicationSelected = (state = store.getState()) => state.app.applicationSelected;

    const downloadData = () => {
        const blob = new Blob([JSON.stringify(props.data)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `integración_cartera_solicitud-${applicationSelected(store.getState()).id}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        setErrors(props.errors);
    }, [props]);

    return (
        <Box margin={4}>
            <Box textAlign={"center"}>
                <img src={WarningCheck} height={"65px"} />
            </Box>
            <Typography variant="body1" color="main3" fontWeight={400} textAlign={"center"} mb={2}>
                Se identificaron los siguientes errores realizar el alta en cartera:
            </Typography>
            <Stack rowGap={1}>
                {errors.map((error) => (
                    <Stack direction={"row"}>
                        <Typography variant="body1" color="main3" fontWeight={400}>
                            {error.loc.join(", ")}:
                        </Typography>
                        <Typography variant="body1" color="main3" fontWeight={500}>
                            {error.msg}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
            <Stack direction={"row"} display={"flex"} justifyContent={"space-around"} mt={3}>
                <Button variant="contained" color="secondary4" onClick={downloadData}>
                    Descargar JSON
                </Button>
                <Button variant="contained" color="main2" onClick={() => dispatch(setDialogConfig())}>
                    Cerrar
                </Button>
            </Stack>
        </Box>
    );
};
